import { useMemo } from 'react';

const useConstraints = ({
  noCompound,
  noSpecial,
  datasetMustIncludeField,
  metricIdsToConstrainBy,
  hideDatasetsWithNoMetrics,
  metricIdRedList,
  aggFuncRedList,
  aggFuncGreenList,
  datasetRedList,
  fieldRedList,
  allowHiddenDatasets,
}: {
  noCompound?: boolean;
  noSpecial?: boolean;
  datasetMustIncludeField?: string;
  metricIdsToConstrainBy?: string[];
  hideDatasetsWithNoMetrics?: boolean;
  metricIdRedList?: string[];
  aggFuncRedList?: AggFunc[];
  aggFuncGreenList?: AggFunc[];
  datasetRedList?: string[];
  fieldRedList?: string[];
  allowHiddenDatasets?: boolean;
}) => {
  const constraints = useMemo<MetricPickerOptionConstraints>(() => {
    return {
      noCompound,
      noSpecial,
      datasetMustIncludeField,
      datasetMustBeSharedWithMetricIds: metricIdsToConstrainBy
        ? metricIdsToConstrainBy.length === 0
          ? undefined
          : metricIdsToConstrainBy
        : undefined,
      hideDatasetsWithNoMetrics,
      metricIdRedList,
      aggFuncRedList,
      aggFuncGreenList,
      datasetRedList,
      fieldRedList,
      allowHiddenDatasets,
    };
  }, [
    aggFuncGreenList,
    aggFuncRedList,
    datasetMustIncludeField,
    allowHiddenDatasets,
    datasetRedList,
    fieldRedList,
    hideDatasetsWithNoMetrics,
    metricIdRedList,
    metricIdsToConstrainBy,
    noCompound,
    noSpecial,
  ]);

  return constraints;
};

export default useConstraints;
